import React from 'react';
import { Navigate, useParams } from 'react-router-dom';

/**
 * 匹配旧链接，跳转到新链接
 * @returns 
 */
const LinkQuestionsDetail: React.FC = () => {
  const params=useParams();
  return (
    <Navigate to={`/technicalSupport/questionsDetail/${params.id}`} replace />
    
  );
};

export default LinkQuestionsDetail;
